export default ({ next, store }) => {
  if (!store.getters.isAdmin) {
    return next({ name: 'time-log-weekly' })
  }

  return next()
}
